import { render } from "./ProductHighlight.vue?vue&type=template&id=304cb23c&scoped=true"
import script from "./ProductHighlight.vue?vue&type=script&lang=js"
export * from "./ProductHighlight.vue?vue&type=script&lang=js"

import "./ProductHighlight.vue?vue&type=style&index=0&id=304cb23c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304cb23c"]])

export default __exports__